<template>
  <v-card
    class="setup-hub-option-card"
    :style="{
      backgroundColor: bgColor,
      borderColor: borderColor,
    }"
  >
    <v-card-text class="pa-4">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    bgColor: {
      type: String,
      default: "rgb(var(--v-theme-white))",
    },
    borderColor: {
      type: String,
      default: "rgb(var(--v-theme-indigo-pale))",
    },
  },
});
</script>

<style scoped lang="scss">
.setup-hub-option-card {
  border: 1px solid;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  &:hover {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  }
}
</style>
